import React, { Fragment } from 'react';
import './App.css';
import Sidebar from './Sidebar';
import CourseArea from './CourseArea';
import Cart from './Cart'
import SearchAndFilter from './SearchAndFilter';
import data from './data/course_data.json'
import completed from './data/complete.json'
import { Row, Col } from 'antd'
import { Navbar } from 'react-bootstrap';
import 'antd/dist/antd.css';
import { notification } from 'antd'


class MainPage extends React.Component {
    constructor(props) {
      super(props);
    }


    render(){
        return (
            <Fragment>
          <Navbar sticky="top" style={{ backgroundColor: 'white', marginBottom: '40px' }}>
            <Col span={1}></Col>
            <div>
              <h1 style={{ fontSize: "30px", fontWeight: "bolder", whiteSpace: 'nowrap' }}>Search & Enroll</h1>
            </div>
            <Sidebar setCourses={(courses) => this.props.setCourses(courses)} courses={this.props.allCourses} subjects={this.props.subjects} />
            <Col span={1}></Col>
          </Navbar>

          <Row>
            <Col span={1}></Col>
            <Col span={13}>
              <CourseArea
                data={this.props.filteredCourses}
                addCartCourse={(data) => this.props.addCartCourse(data)}
                removeCartCourse={(data) => this.props.removeCartCourse(data)}
                cartCourses={this.props.cartCourses}
                completedCourses={this.props.completedCourses}
              />
            </Col>
            <Col span={1}></Col>
            <Col span={8}>
              <Cart
                data={this.props.getCartData()}
                addCartCourse={(data) => this.props.addCartCourse(data)}
                removeCartCourse={(data) => this.props.removeCartCourse(data)}
                cartCourses={this.props.cartCourses}
                clearCart={() => this.props.clearCart()}
              >
              </Cart>
            </Col>
            <Col span={1}></Col>
          </Row>
        </Fragment>
        )
    }
}

export default MainPage;
